<template>
  <siquick-card title="Grading System Settings">
    <template v-slot:card-content>
        <v-layout row wrap>

            <v-flex xs12>
                <v-text-field label="Class Score (%)*" type="number" step="any" v-model="sinf_model.class_score"/>
            </v-flex>
             <v-flex xs12>
                <v-text-field label="Exams Score (%)*" type="number" step="any" v-model="sinf_model.exam_score"/>
            </v-flex>
            <v-btn class="success" @click="savesetting()" :loading="loading">Save</v-btn>
        </v-layout>
    </template>
  </siquick-card>
</template>

<script>
import QuickCard from "../Quickcard";
import { mapGetters } from "vuex";
export default {
  name: "sms-settings",
  components: {
    "siquick-card": QuickCard
  },
  data(){
    return{
      sinf_model:{
        class_score:'',
        exam_score:'',
      },
       sinf_modelcp:{
        class_score:'',
        exam_score:'',
      },
    }
  },
   created() {
    this.$store.dispatch("settings/getAll")
  },
  computed: {
    ...mapGetters({
      settings: "settings/SETTINGS",
      sierrors: "settings/SETTING_ERROR",
      loading: "settings/SETTING_LOADING"
    })
  },
  methods: {
      savesetting() {

      var score_sum = parseFloat(this.sinf_model.class_score)+parseFloat(this.sinf_model.exam_score)
      if(score_sum<100){
        this.$toast.error("The sum of class score and exam score must not be less than 100%")
        return
      }
        //console.log("pagtraaaaa",this.sinf_model)
      this.$store.dispatch("settings/add", this.sinf_model);

      if (this.sierrors==null) {

          this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Settings saved successfully",
                title: "Settings",
                modal: false
            })
      }else{
        this.sinf_model = this.sinf_modelcp;
          this.$store.dispatch('responseMessage', {
                type: 'warning',
                text: "Sorry, settings could not be saved",
                title: "Settings",
                modal: false
            })
      }
    },

  },
  watch:{
    settings(val){
       if (this.sierrors==null && this.settings.school) {
        this.sinf_model.class_score = val.school && val.school.class_score?val.school.class_score:0;
        this.sinf_model.exam_score = val.school && val.school.exam_score?val.school.exam_score:0;

      }
    }
  }


};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/settings/class_assessment.vue